export var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
export var SHA256_HEADER = "X-Amz-Content-Sha256";
export var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
export var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
export var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
export var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
export var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
export var HOST_HEADER = "host";
export var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";